module.exports = __webpack_public_path__ + "img/title.ed80176e.png";